export default __webpack_public_path__ + "static/lovdata-ki-sok-cc0943698df944cbc61fd8eb7e774a42.png";